import {cn, cva} from 'platform/shared';

import type {ComponentPropsWithoutRef} from 'react';

const footerBarVariants = cva(
  'flex items-center justify-between gap-2 border-t border-solid border-t-[var(--color-palettes-neutral-30-100)] bg-[var(--color-palettes-neutral-10-100)] px-2 py-1'
);

export function FooterBar(props: ComponentPropsWithoutRef<'div'>) {
  return <div {...props} className={cn(footerBarVariants(), props.className)} />;
}

const footerContentVariants = cva('flex min-w-0 flex-1 flex-wrap items-center justify-end gap-2');

/** Status content between the selection path and the counter; it wraps rather than widen the row. */
export function FooterContent(props: ComponentPropsWithoutRef<'div'>) {
  return <div {...props} className={cn(footerContentVariants(), props.className)} />;
}

export type FooterCounterProps = ComponentPropsWithoutRef<'span'> & {
  $isOverLimit: boolean;
  $isNearLimit?: boolean;
};

const footerCounterVariants = cva('text-[length:var(--text-size-x-small)]', {
  variants: {
    isOverLimit: {
      true: 'text-[var(--color-severity-danger)]',
      false: '',
    },
    isNearLimit: {
      true: 'text-[var(--color-severity-warning)]',
      false: '',
    },
  },
  compoundVariants: [
    {
      isOverLimit: true,
      isNearLimit: true,
      className: 'text-[var(--color-severity-danger)]',
    },
    {
      isOverLimit: false,
      isNearLimit: false,
      className: 'text-[var(--color-text-secondary)]',
    },
  ],
});

export function FooterCounter(props: FooterCounterProps) {
  const {$isOverLimit, $isNearLimit, className, ...htmlProps} = props;

  return (
    <span
      {...htmlProps}
      className={cn(
        footerCounterVariants({isOverLimit: $isOverLimit, isNearLimit: $isNearLimit}),
        className
      )}
    />
  );
}
